import { Language } from "../../models/Translation";

export const REQUEST_LANGUAGES = "REQUEST_LANGUAGES";

export interface FetchLanguages {
  type: typeof REQUEST_LANGUAGES;
  payload: ReadonlyArray<Language>;
}

export type LanguageActionTypes = FetchLanguages;

export interface LanguageState {
  languages: ReadonlyArray<Language>;
}
